export default "__VITE_ASSET__1f396771__"